<template>
  <td class="v-data-table__mobile-row">
    <div class="v-data-table__mobile-row__header">{{ title }}</div>
    <div class="v-data-table__mobile-row__cell">{{ montant }}</div>
  </td>
</template>

<script>
export default {
  props: {
    title: String,
    montant: String
  }
}
</script>

<style>
</style>